import {Mapper} from '@s-ui/domain'

export default class FromModelsHttpRepositoryDataToModelsValueObjectMapper extends Mapper {
  constructor({mapper, valueObject}) {
    super()
    this._mapper = mapper
    this._valueObject = valueObject
  }

  _getBodyTypeDoorsGroup = (bodyType, doors, list) => {
    const result = {}
    list.forEach((group, index) => {
      if (group.bodyType === bodyType && group.doors === doors) {
        result.isAlreadyIncluded = true
      }
      result.index = index
    })
    return result
  }

  map = ({makeUrlParam, modelsList}) => {
    modelsList = modelsList.reduce((groupedModels, model) => {
      const {bodyType, doors} = model
      const matchedGroup = this._getBodyTypeDoorsGroup(bodyType, doors, groupedModels)

      matchedGroup.isAlreadyIncluded
        ? groupedModels[matchedGroup.index].models.push(this._mapper.map({model, makeUrlParam}))
        : groupedModels.push({
            bodyType,
            doors,
            models: [this._mapper.map({model, makeUrlParam})]
          })

      return groupedModels
    }, [])

    return this._valueObject({modelsList})
  }
}
